import { CoreIcon } from '../core-icon';
import repairColorSVG from '../../assets/icons/repair-color.svg';
import type { IconProps } from '../core-icon';

export const RepairColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={repairColorSVG} {...props} />;
};
